var ur = window.location.href;

  jQuery(document).ready(function(){
      $('span.quick-view-button').click(function(){
          var q = $(this).closest('.t4s-product');
        var qv = 0; var timerqv = setInterval(function(){
          if(q.find('span.t4s-svg-pr-icon').length) {
        q.find('span.t4s-svg-pr-icon').eq(0).click();
      clearInterval(timerqv);}if( qv > 200){clearInterval(timerqv);}qv++;}, 50);

      }); 
});




var ur = window.location.href;
if(ur.includes('/cart')){
  
 jQuery(document).ready(function(){


   
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};

var badgeTexts = ["Lifetime Guarantee",
                  "Free US Shipping for Orders $80 or More",
                  "Easy 30 Day Returns"];
    
var popup = ["", "simple-shipping",   "simple-return"];
var imgSrcs = ['https://cdn.shopify.com/s/files/1/2625/5272/files/Group_11.png?v=1730382316',
              'https://cdn.shopify.com/s/files/1/2625/5272/files/Group_9_1.png?v=1730382316',
              'https://cdn.shopify.com/s/files/1/2625/5272/files/Group_13.png?v=1730382316']
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('p.t4s-cart__tax')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
 
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  var prodName = jQuery('h1.product_name').html();
  
  
}
   var svv = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_17_1076" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
<rect width="18" height="18" fill="#464D60"/>
</mask>
<g mask="url(#mask0_17_1076)">
<path d="M8.25006 12.75H9.75006V8.25H8.25006V12.75ZM9.00006 6.75C9.21256 6.75 9.39069 6.67812 9.53444 6.53438C9.67819 6.39062 9.75006 6.2125 9.75006 6C9.75006 5.7875 9.67819 5.60938 9.53444 5.46562C9.39069 5.32187 9.21256 5.25 9.00006 5.25C8.78756 5.25 8.60944 5.32187 8.46569 5.46562C8.32194 5.60938 8.25006 5.7875 8.25006 6C8.25006 6.2125 8.32194 6.39062 8.46569 6.53438C8.60944 6.67812 8.78756 6.75 9.00006 6.75ZM9.00006 16.5C7.96256 16.5 6.98756 16.3031 6.07506 15.9094C5.16256 15.5156 4.36881 14.9813 3.69381 14.3063C3.01881 13.6313 2.48444 12.8375 2.09069 11.925C1.69694 11.0125 1.50006 10.0375 1.50006 9C1.50006 7.9625 1.69694 6.9875 2.09069 6.075C2.48444 5.1625 3.01881 4.36875 3.69381 3.69375C4.36881 3.01875 5.16256 2.48438 6.07506 2.09063C6.98756 1.69687 7.96256 1.5 9.00006 1.5C10.0376 1.5 11.0126 1.69687 11.9251 2.09063C12.8376 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5157 5.1625 15.9094 6.075C16.3032 6.9875 16.5001 7.9625 16.5001 9C16.5001 10.0375 16.3032 11.0125 15.9094 11.925C15.5157 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8376 15.5156 11.9251 15.9094C11.0126 16.3031 10.0376 16.5 9.00006 16.5ZM9.00006 15C10.6751 15 12.0938 14.4187 13.2563 13.2563C14.4188 12.0938 15.0001 10.675 15.0001 9C15.0001 7.325 14.4188 5.90625 13.2563 4.74375C12.0938 3.58125 10.6751 3 9.00006 3C7.32506 3 5.90631 3.58125 4.74381 4.74375C3.58131 5.90625 3.00006 7.325 3.00006 9C3.00006 10.675 3.58131 12.0938 4.74381 13.2563C5.90631 14.4187 7.32506 15 9.00006 15Z" fill="#464D60"/>
</g>
</svg>
`;
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="'+imgSrcs[i]+'"><span class="badge'+i+'" id="'+popup[i]+'">'+badgeTexts[i]+ svv + '</span></div>';

    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
});
  

jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
  
      
  var cont = jQuery('#shipping-p').html();
  jQuery('body').append(jQuery(`<div class="simple-popup simple-shipping-popup">
  <div class="popup-content">
    <div class="popup-title">Shipping Policy wd<span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
      `+cont+`
      </div>
    </div>
  </div>
</div>`))

var cont = jQuery('#returns-p').html()
     jQuery('body').append(jQuery(`<div class="simple-popup simple-return-popup">
  <div class="popup-content">
    <div class="popup-title">Easy 30 day returns <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
      `+cont+`
      </div>
    </div>
  </div>
</div>`))
    
  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')

  });   
  
        jQuery('#simple-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-return-popup').eq(0).addClass('open')
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
  jQuery('.product_infos').removeClass('show-popup');
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
}